module.exports = __webpack_public_path__ + "img/logitechg.31b7418c.svg";